import {
    ButtonFlavor,
    ButtonSize,
    ButtonType,
    ExButton,
    ExIcon,
    ExIconButton,
    IconButtonFlavor,
    IconButtonSize,
    IconButtonType,
} from '@boomi/exosphere';

import './confirmation-dialog.css';

interface Props {
    title: string;
    message: string;
    cancelText: string;
    confirmText: string;
    onClose: () => void;
    onCancel: () => void;
    onConfirm: () => void;
}

const ConfirmationDialog = ({
    title,
    message,
    cancelText,
    confirmText,
    onClose,
    onCancel,
    onConfirm,
}: Props) => (
    <div className="confirmation-dialog-wrapper">
        <div className="confirmation-dialog">
            <header className="confirmation-dialog-header">
                <ExIcon icon="Information" hide-browser-tooltip />
                <h4 className="text lg">{title}</h4>
                <ExIconButton
                    slot="anchor"
                    icon="Close"
                    circular={true}
                    flavor={IconButtonFlavor.BRANDED}
                    size={IconButtonSize.DEFAULT}
                    type={IconButtonType.TERTIARY}
                    onClick={onClose}
                    hideBrowserTooltip
                />
            </header>
            <p className="text sm">{message}</p>
            <footer className="confirmation-dialog-footer">
                <ExButton
                    flavor={ButtonFlavor.RISKY}
                    type={ButtonType.SECONDARY}
                    size={ButtonSize.LARGE}
                    onClick={onCancel}
                >
                    {cancelText}
                </ExButton>
                <ExButton
                    flavor={ButtonFlavor.BASE}
                    type={ButtonType.PRIMARY}
                    size={ButtonSize.LARGE}
                    onClick={onConfirm}
                >
                    {confirmText}
                </ExButton>
            </footer>
        </div>
    </div>
);

export default ConfirmationDialog;
